import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-header-nudge',
  templateUrl: './header-nudge.component.html',
  styleUrls: ['./header-nudge.component.scss']
})
export class HeaderNudgeComponent implements AfterViewInit, OnChanges {
  @Input() nudgeConfiguration = null;
  iconSvg: SafeHtml;
  message: SafeHtml;

  constructor(
    private  sanitizer: DomSanitizer
  ) { 
  }

  ngAfterViewInit(): void {
    if (this.nudgeConfiguration) {
      this.changeContent();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.nudgeConfiguration.currentValue) {
      this.changeContent();
    }
  }

  changeContent() {
    this.iconSvg = this.sanitizer.bypassSecurityTrustHtml(this.nudgeConfiguration.icon);
    const baseMessage = this.nudgeConfiguration.title;
    const readMoreUrl = this.nudgeConfiguration.readMoreUrl;

    if (readMoreUrl) {
      const formattedMessage = `${baseMessage} <a class="read-more-link" href="${readMoreUrl}" target="_blank">Read More</a>`;
      this.message = this.sanitizer.bypassSecurityTrustHtml(formattedMessage);
    } else {
      this.message = this.sanitizer.bypassSecurityTrustHtml(baseMessage);
    }

  }

}
